import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BomOptionsStepSeparateQuantity } from '../../../../bom/constants';
import FeedbackWrapper from '../../../common/FeedbackWrapper';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';
import SelectWrapper from '../SelectWrapper';
import StepNumber from '../StepNumber';
import { formatQuantity } from '../../../../utils/formatter';
import { getQuantities } from '../../../../price/selectors';
import { getQuantity } from '../../../../bom/selectors';
import { saveQuantity } from '../../../../bom/actions';

const ExactQuantityDropdown = ({ feedback, resetFeedback }) => {
  const dispatch = useDispatch();

  const originalQuantity = useSelector(getQuantity);
  const quantities = useSelector(getQuantities);

  const [selectedOption, setSelectedOption] = useState(
    originalQuantity > 0
      ? {
          label: formatQuantity(originalQuantity),
          value: originalQuantity,
        }
      : null
  );

  const options = quantities.map((quantity) => ({
    label: formatQuantity(quantity),
    value: quantity,
  }));

  const handleChange = (option) => {
    if (!selectedOption || (!!selectedOption && selectedOption.value !== option.value)) {
      setSelectedOption(option);
      dispatch(saveQuantity(option.value));
      resetFeedback('quantity');
    }
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label id="exact-quantity-dropdown-label">
        <StepNumber step={BomOptionsStepSeparateQuantity} />
        Quantity:
      </Form.Label>
      <SelectWrapper
        aria-labelledby="exact-quantity-dropdown-label"
        id="exact-quantity-dropdown"
        isInvalid={!!feedback['quantity']}
        isSearchable={false}
        options={options}
        placeholder="Select quantity"
        value={selectedOption}
        onChange={handleChange}
      />
      {!!feedback['quantity'] && <FeedbackWrapper>{feedback['quantity']}</FeedbackWrapper>}
    </Form.Group>
  );
};

ExactQuantityDropdown.propTypes = {
  feedback: PropTypes.objectOf(PropTypes.string).isRequired,
  resetFeedback: PropTypes.func.isRequired,
};

export default ExactQuantityDropdown;
